import { CustomStatusMapper } from '@csp/csp-common-custom-status';
import { ZonedDateTimeFactory, ZonedDateTimeFormatter } from '@csp/csp-common-date-util';
import { CustomStatus } from '@csp/csp-common-model';
import { VisitConfirmationStatusType } from './VisitConfirmationStatusType';
import { VisitCustomStatusType } from './VisitCustomStatusType';

export type VisitConfirmationStatus = CustomStatus<VisitConfirmationStatusType>;

const toUnknown = (): VisitConfirmationStatus => {
  const unknownTimestamp = ZonedDateTimeFormatter.toIsoFormattedString(ZonedDateTimeFactory.fromUnixTimeMillis(0));
  return CustomStatusMapper.fromCustomStatusV1({
    type: VisitCustomStatusType.CONFIRMATION,
    value: VisitConfirmationStatusType.UNKNOWN,
    createdAt: unknownTimestamp,
    localTimestamp: unknownTimestamp,
    previousCustomStatuses: [],
  }) as VisitConfirmationStatus;
};

export const VisitConfirmationStatus = {
  toUnknown,
};
